import React, { Component } from "react";
//import BreadCrumbWrapper from './BreadCrumbWrapper'
import { $ } from "../shared/utils";
const error404 = "https://s3.amazonaws.com/maxmilhas/website/img/general/noFlights.png";

export default class ErrorContainerMessage extends Component {
	constructor() {
		super();
	}

	reSearch() {
		if ($("#trip_resume") !== null) {
			$("#trip_resume").click();
		}
	}

	render() {
		let header =
			this.props.errorType === "500" ? (
				<div className="general-info">
					<h3 className="lead">VOOS NÃO ENCONTRADOS</h3>
					{/*<BreadCrumbWrapper active={1}/>*/}
				</div>
			) : null;

		let button =
			this.props.button === "true" ? (
				<button className="btn btn-success hidden-md hidden-lg btn-sm" onClick={this.reSearch}>
					<i className="icon-search" />Pesquisar novamente
				</button>
			) : null;

		return (
			<div className="searchpage">
				<section className="container-fluid">
					{header}
					<div className="errorpage erro500">
						<div className="row">
							<div className="hidden-xs hidden-sm col-md-8 v-center-columns">
								<img className="img-responsive" src={error404} alt="" />
							</div>
							<div className="col-xs-16 col-md-5 v-center-columns">
								<h1>{this.props.title}</h1>
								<h3>{this.props.subtitle}</h3>
								<div className="separator" />
								<img className="img-responsive visible-xs visible-sm" src={error404} alt="" />
								<div className="useful-links">
									<p>{this.props.text}</p>
									{button}
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}
